// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, nullOrUndefined, boolean, number } from "@altostra/type-validations/lib/primitives";

export const isAppsCatalogsCatalogIdFilteredSetsFilteredSetNameResult = objectOf({
  id: string,
  name: string,
  description: string,
  created_at: anyOf(nullOrUndefined, number),
  updated_at: anyOf(nullOrUndefined, number),
  filters: arrayOf(
    objectOf({
      field: string,
      operator: string,
      value: anyOf(string, arrayOf(string)),
      type: string,
    })
  ),
  sort_field: anyOf(nullOrUndefined, string),
  sort_order: anyOf(nullOrUndefined, boolean),
  processing: boolean,
  results_limit: number,
  source: string,
});
